module.exports = __webpack_public_path__ + "img/lucky_bk_p3.8a43b76b.png";